function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.5 117v6.5h-17V117h0M55.5 117v6.5h-17V117h0"
}), /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 100,
  x: 0.5,
  y: 19.5,
  rx: 14.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 87,
  x: 32.5,
  y: 32.5,
  rx: 14.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.5.5h9a6 6 0 016 6v13.173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 19.682V7.5a3 3 0 00-3-3h-9m44 28.195V16.5a3 3 0 00-3-3H16.59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.333 9.5H42.5a6 6 0 016 6v17.27"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M12.5 11.5h-3m35 13h-3m-32-15v4m32 9v4m-29-19h4m28 13h4m-36-5h4m28 13h4"
}));

function SvgRoomWaterTreatment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 124,
    viewBox: "0 0 62 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomWaterTreatment);
export default __webpack_public_path__ + "static/media/RoomWaterTreatment.03a0b999.svg";
export { ForwardRef as ReactComponent };